import styled from 'styled-components';

import { fontFamilyPrimary, mediaQueryLaptopMin } from '@/styleUtils/variables';

export const ContentFooter = styled.div`
  display: flex;
  flex-direction: column;

  @media all and ${mediaQueryLaptopMin} {
    width: 100%;
    flex-direction: row;
  }
`;

export const Main = styled.div`
  align-items: flex-start;
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  gap: 16px;
  height: fit-content;

  @media all and ${mediaQueryLaptopMin} {
    width: calc(100% - 316px);
  }
`;

export const Title = styled.h2`
  font: normal 700 40px/100% ${fontFamilyPrimary};
  letter-spacing: -1.2px;
  margin: 0 0 32px;
`;
